// One face over both maps for Check Wind: where to draw, how lat/lng lands on screen, and the map's moves
// and clicks. The 2D map is Google Maps; the 3D map is MapTiler (MapLibre).

function googleSurface(map) {
  const host = document.createElement('div')
  host.className = 'check-wind-host'
  map.getDiv().appendChild(host)

  // Google hands out its projection only to an overlay on the map.
  const probe = new google.maps.OverlayView()
  probe.onAdd = () => {}
  probe.draw = () => {}
  probe.onRemove = () => {}
  probe.setMap(map)

  return {
    host,
    project({ lat, lng }) {
      const projection = probe.getProjection()
      if (!projection) return null
      const p = projection.fromLatLngToContainerPixel(new google.maps.LatLng(lat, lng))
      return p ? { x: p.x, y: p.y } : null
    },
    unproject({ x, y }) {
      const projection = probe.getProjection()
      if (!projection) return null
      const ll = projection.fromContainerPixelToLatLng(new google.maps.Point(x, y))
      return ll ? { lat: ll.lat(), lng: ll.lng() } : null
    },
    size: () => ({ width: host.clientWidth, height: host.clientHeight }),
    // Google's tiles are 256 px.
    metresPerPx: lat => 156543.03392 * Math.cos(lat * Math.PI / 180) / Math.pow(2, map.getZoom()),
    onMove(fn) {
      const listeners = ['bounds_changed', 'projection_changed', 'idle'].map(e => google.maps.event.addListener(map, e, fn))
      // The projection arrives a beat after the overlay is added.
      const timer = setTimeout(fn, 50)
      return () => { clearTimeout(timer); listeners.forEach(l => l.remove()) }
    },
    onClick(fn) {
      const l = google.maps.event.addListener(map, 'click', e => fn({ lat: e.latLng.lat(), lng: e.latLng.lng() }))
      return () => l.remove()
    },
    setCursor: cursor => map.setOptions({ draggableCursor: cursor || null }),
    centreOn({ lat, lng }, zoom) {
      map.panTo({ lat, lng })
      if (zoom && map.getZoom() < zoom) map.setZoom(zoom)
    },
    destroy() {
      probe.setMap(null)
      host.remove()
    }
  }
}

function maplibreSurface(map) {
  const host = document.createElement('div')
  host.className = 'check-wind-host'
  map.getContainer().appendChild(host)

  return {
    host,
    project({ lat, lng }) {
      const p = map.project([lng, lat])
      return { x: p.x, y: p.y }
    },
    unproject({ x, y }) {
      const ll = map.unproject([x, y])
      return { lat: ll.lat, lng: ll.lng }
    },
    size: () => ({ width: host.clientWidth, height: host.clientHeight }),
    // MapLibre's tiles are 512 px.
    metresPerPx: lat => 78271.517 * Math.cos(lat * Math.PI / 180) / Math.pow(2, map.getZoom()),
    // 'idle' too: terrain arriving under a still camera moves where points land.
    onMove(fn) {
      const events = ['move', 'resize', 'idle']
      events.forEach(e => map.on(e, fn))
      const timer = setTimeout(fn, 0)
      return () => { clearTimeout(timer); events.forEach(e => map.off(e, fn)) }
    },
    onClick(fn) {
      const handler = e => fn({ lat: e.lngLat.lat, lng: e.lngLat.lng })
      map.on('click', handler)
      return () => map.off('click', handler)
    },
    setCursor: cursor => { map.getCanvas().style.cursor = cursor || '' },
    centreOn({ lat, lng }, zoom) {
      map.flyTo({ center: [lng, lat], zoom: zoom && map.getZoom() < zoom ? zoom : map.getZoom() })
      // A flight into high ground can end holding the centre elevation from where it set out, leaving the
      // camera inside the terrain and the map blank. A jump in place re-reads it; again once the terrain is in.
      const resync = () => map.jumpTo({ center: map.getCenter() })
      map.once('moveend', () => { resync(); map.once('idle', resync) })
    },
    destroy() {
      host.remove()
    }
  }
}

export const surfaceFor = (kind, map) => (kind === '3d' ? maplibreSurface(map) : googleSurface(map))
